import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HeaderWrapper from '../HeaderWrapper';
import TextField from '@material-ui/core/TextField';

const HeaderWrapperStyled = styled(HeaderWrapper)`

`

class ChipSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleChange = event => {
    const { onChange } = this.props;
    onChange(event.target.value);
  };

  render() {
    const { options, placeholder, onChange, onBlur, type, maxLength, multiline, value, ...other } = this.props;
    return (
      <HeaderWrapperStyled {...other}>
        <TextField
          placeholder={placeholder}
          value={value}
          type={type}
          margin="normal"
          onChange={this.handleChange}
          onBlur={onBlur}
          InputProps={{disableUnderline:true}}
          inputProps={{ maxLength: maxLength }}
          fullWidth
          multiline={multiline}
        />
      </HeaderWrapperStyled>
    )
  }
}

ChipSelect.propTypes = {
  value: PropTypes.string,
  multiline: PropTypes.bool,
  maxLength: PropTypes.number,
};

ChipSelect.defaultProps = {
  multiline: true,
};

export default ChipSelect;
